import { useContext } from 'react';
import QuestionnaireFormContext, { QuestionnaireFormContextType } from './QuestionnaireFormContext';

const useQuestionnaireFormContext = (): QuestionnaireFormContextType => {
  const context = useContext(QuestionnaireFormContext);
  if (!context) {
    throw new Error('useQuestionnaireContext must be used within a QuestionnaireFormProvider');
  }
  return context;
};

export default useQuestionnaireFormContext;